import { Component } from 'react'

class TextArea extends Component {
    state = { focused: false }

    onFocus = () => {
        this.setState({ focused: true })
        if (this.props.onFocus)
            this.props.onFocus()
    }
    onBlur = () => {
        this.setState({ focused: false })
        if (this.props.onBlur)
            this.props.onBlur()
    }

    render() {
        let className = 'text-area'
        if (this.props.value || this.props.placeholder || this.state.focused)
            className += ' text-area--label-raised'
        if (this.state.focused)
            className += ' text-area--focused'
        if (this.props.disabled)
            className += ' text-area--disabled'

        return (
            <label className={className}>
                <span className="text-area__span">{this.props.label + (this.props.required ? '*' : '')}</span>
                <textarea 
                    type="text" 
                    rows={this.props.rows || 5}
                    {...this.props}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur} />
            </label>
        )
    }
}

export default TextArea